import { POS_ROUTE } from "../../constants/constants"

export const ACCOUNTING_PAYMENT_RECEIVED_ROUTE = POS_ROUTE + "/accounting/payment-received"
export const ACCOUNTING_PAYMENT_PAID_ROUTE = POS_ROUTE + "/accounting/payment-paid"
export const ACCOUNTING_BANK_INFO_ROUTE = POS_ROUTE + "/accounting/bank-info"
export const ACCOUNTING_CHARTS_OF_ACCOUNT_ROUTE = POS_ROUTE + "/accounting/charts-of-account"
